import EnterDataForm from './enter-data-form/enter-data-form';
import EnterDataComponent from './enter-data-component'
import EnterDataService from './enter-data-service';
import FilterBar from './filter-bar/filter-bar';

/***
 * The Enter Data page, containing both the filter-bar and the enter-data-form.
 */
const enterData = angular
    .module('FacilityData.EnterData', [
        EnterDataForm,
        FilterBar
    ])
    .component('enterData', EnterDataComponent)
    .service('EnterDataService', EnterDataService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.enter-data', {
                url: '/enter-data/',
                component: 'enterData',
                resolve: {
                    updateUser: (
                        $state,
                        CurrentUser,
                        EnterDataFormService
                    ) =>  CurrentUser.updateCurrentUser({}, EnterDataFormService.autoSaveStats, EnterDataFormService),
                    userAuth: (
                        $state,
                        updateUser,
                        CurrentUser
                    ) => {
                        if (!CurrentUser.isFacilityAdmin()) {
                            $state.go('app.home', {}, {reload: true});
                        }
                    },
                    clientList: (CommonRequest) => CommonRequest.getClients({has_user_permissions: 1}),
                    changeReasonList: (EnterDataService) => EnterDataService.getChangeReasons(),
                    relatedModels: (FacilitySettings) => FacilitySettings.getRelatedModels(),
                    facilityFields: (FacilitySettings) => FacilitySettings.getFacilityFields(),
                }
            });
    })
    .name;

export default enterData


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data.js